export default function SelfAssessments() {
  const assessments = [
    {
      title: 'Anxiety Assessment',
      description: 'Understand your anxiety patterns and identify triggers affecting your daily life.',
      duration: '5-10 minutes',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Depression Screening (Coming Soon)',
      description: 'Gain insight into mood patterns and emotional wellbeing indicators.',
      duration: '5-10 minutes',
      icon: 'ri-mental-health-line'
    },
    {
      title: 'Burnout Screening (Coming Soon)',
      description: 'Identify the presence and severity of emotional burnout.',
      duration: '5-10 minutes',
      icon: 'ri-pulse-line'
    },
  ];

  return (
    <section id="self-assessments" className="py-24 bg-[#F0F4F8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <h2 className="text-5xl font-serif text-[#2F7FB7] mb-6">Self-Assessments</h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            The Self-Assessments section is a private, gentle space designed to help you better understand your emotional wellbeing.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            These tools offer insight into what you may be experiencing, why certain feelings or patterns are showing up, and which areas of your wellbeing may need a little extra care and attention right now.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {assessments.map((assessment, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E8F1F5] group-hover:bg-[#2F7FB7] transition-colors">
                  <i className={`${assessment.icon} text-2xl text-[#2F7FB7] group-hover:text-white transition-colors`}></i>
                </div>
                <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full whitespace-nowrap">
                  {assessment.duration}
                </span>
              </div>
              <h3 className="text-2xl font-serif text-[#2F7FB7] mb-3">{assessment.title}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{assessment.description}</p>
              <a href="/download" className="text-[#2F7FB7] font-medium inline-flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer">
                Start Assessment
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#2F7FB7] to-[#1E5A8E] rounded-3xl p-10 text-white">
          <div className="max-w-3xl">
            <h3 className="text-3xl font-serif mb-4">Why Self-Assessments Matter</h3>
            <p className="text-lg leading-relaxed mb-6 text-white/90">
              Self-assessments can be powerful because they help you take the guesswork out of how you're really doing. There are no right or wrong answers — only information to help you care for yourself with greater understanding and compassion.
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl flex-shrink-0 mt-1"></i>
                <span>Gain clarity around emotional patterns</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl flex-shrink-0 mt-1"></i>
                <span>Notice what is improving over time</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl flex-shrink-0 mt-1"></i>
                <span>Understand your unique triggers</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl flex-shrink-0 mt-1"></i>
                <span>Connect with the right support tools</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
